import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    coOpActionCreators,
    CoOpActionKeys,
    FetchCoOpSalesDistrictBudgets,
    ICoOpSalesDistrictBudget
    } from '..';
import { uiActionCreators } from '../../ui';
import {} from '../coOpInterfaces';

function* fetchCoOpSalesDistrictBudgetsSaga(action: FetchCoOpSalesDistrictBudgets) {
  yield put(uiActionCreators.toggleLoading('coOpGlobalSettings'));
  const { fiscalYear, salesDistricts } = action.payload;
  const response: ICoOpSalesDistrictBudget[] = yield call(
    api.fetchCoOpSalesDistrictBudgets,
    salesDistricts,
    fiscalYear
  );

  yield put(coOpActionCreators.setSalesDistrictBudgets(response));
  yield put(uiActionCreators.toggleLoading('coOpGlobalSettings'));
}

export function* watchFetchCoOpSalesDistrictBudgets() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_SALESDISTRICT_BUDGETS, fetchCoOpSalesDistrictBudgetsSaga);
}
